import React, {useEffect, useState }   from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import FamikarHeader from '../components/FamikarHeader';
import AppBar        from '@material-ui/core/AppBar'
import Grid          from '@material-ui/core/Grid';
import TextField     from '@material-ui/core/TextField';
import Input         from '@material-ui/core/Input';
import Button        from '@material-ui/core/Button';
// import InputLabel    from '@material-ui/core/InputLabel';
// import MenuItem      from '@material-ui/core/MenuItem';
// import FormControl   from '@material-ui/core/FormControl';
// import Select        from '@material-ui/core/Select';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

let uid = ''          //招待送信者のuidを格納する。
let tmpFamilyIDs = [] //FamilyIDを格納
let sender = ''      //送信者名を格納
let displayNames = [] //メンバー表示名リスト
//let FamilyName        //家族名一時格納

let memberList = [ //メンバー一覧用
  // {
  //   FamilyID:    [],  //家族ID
  //   MemberID:    "",   //メンバーID
  //   DisplayName: '', //メンバー表示名
  // }
]
let memberPermission = ''
let InvitationID = '' 

export default function Invitation(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const { familyID } = useParams()
  const [IsLogin,          setIsLogin          ] = useState(false)
  const [Uid,              setUid              ] = useState('')
  const [FamilyID,         setFamilyID         ] = useState(familyID ? familyID : '') //家族ID
  const [Invitation_Email, setInvitation_Email ] = useState('') //招待対象者のEメールアドレス
  const [Invitation_Name,  setInvitation_Name  ] = useState('') //招待対象者のお名前
  const [Sender_Name,      setSender_Name      ] = useState('') //招待送信者名
  const [Sender_ID,        setSender_ID        ] = useState('') //招待送信者のuid
  const [Message,          setMessage          ] = useState('') //招待対象者宛のメッセージ
  const [Permission,       setPermission       ] = useState('') //招待対象者のアクセス権
  const [MemberPermission, setMemberPermission ] = useState('') //招待対象者のアクセス権
  const [MemberList,       setMemberList       ] = useState([]) //メンバー一覧
  const [DisplayNames,     setDisplayNames     ] = useState([]) //メンバー表示名リスト

  //MemberPermission: [],                                 //招待対象者のゲストアクセス権付与対象メンバー情報
  //MemberList: [],                                       //メンバー一覧
  //DisplayNames: [],                                     
  //FamilyName: '',                                       //家族名

  // componentDidMount() { //ページ表示時、情報更新時に実行
  //   console.log("compoonentDidMount: this.state.FamilyID["+this.state.FamilyID+"]")
  //   const db = firebase.firestore();
  //   this.getLoginInfo(db) // ログイン情報取得
  // }

  // ログイン情報取得
  const getLoginInfo = (db) => {
    console.log("Invitation.js getLoginInfo()")
    Promise.resolve().then(()=>{
      return new Promise((resolve)=>{
        firebase.auth().onAuthStateChanged((user)=>{ //現在ログインしているユーザーを取得する。
          if (user) {
            uid = user.uid //ログインユーザーのuidを取得する
            setIsLogin(true)
            resolve()
          }
        })
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{
        if (FamilyID === '') {
          db.collection("Person").doc(uid).get().then((Person_result)=>{ //ログインユーザー情報から、家族IDの情報を取得する
            tmpFamilyIDs.push(Person_result.data().FamilyID[0].id) //1件目の家族IDを取得する。
            sender = Person_result.data().FamilyName + ' ' + Person_result.data().FirstName //招待送信者名を取得する
            window.history.replaceState(null, null, "/Invitation/" + tmpFamilyIDs[0]) //URLに家族IDが含まれない場合は、家族IDを含むURLに書き替えを行う。
            resolve()
          })
        } else {
          tmpFamilyIDs.push(FamilyID) //1件目の家族IDを取得する。
          db.collection("Person").doc(uid).get().then((Person_result)=>{ //ログインユーザー情報から、家族IDの情報を取得する
            sender = Person_result.data().FamilyName + ' ' + Person_result.data().FirstName //招待送信者名を取得する
            resolve()
          })
        }
      })
    })
    .then(()=>{
      return new Promise((resolve)=>{ //家族のメンバー情報を取得する。
        db.collection("Family").doc(tmpFamilyIDs[0]).collection("Member").orderBy("DisplayName").get().then((result)=>{
          memberList = []
          displayNames = []
          result.forEach((doc)=> {
            let dataT = doc.data()
            let DeleteFlag = (dataT.DeleteFlag == null) ? false : dataT.DeleteFlag //家族情報の削除フラグがある場合は、非表示にする。
            if (DeleteFlag === false) {
              memberList.push({
                FamilyID:    tmpFamilyIDs[0],    //家族ID
                MemberID:    doc.id,             //メンバーID
                DisplayName: dataT.DisplayName,  //メンバー表示名
              })
              displayNames.push(doc.id)
            }
          })
          //console.dir(MemberList)
          //console.dir(DisplayNames)
          resolve()
        }).catch(function(error) {
          console.log("Error getting family member documents: ", error)
          resolve()
        })
      })
    })
    .then(()=>{
      //console.log("uid: " + uid)
      setUid(uid)                   //ログインユーザーのuid
      setFamilyID(tmpFamilyIDs[0])  //家族ID
      setSender_Name(sender)        //招待送信者名
      setMemberList(memberList)     //メンバー一覧用
      setDisplayNames(displayNames) //メンバー表示名リスト
    })
  }

  const handleChange = (e) => {
    // console.log("set" + e.target.name + "(\"" + e.target.value + "\")")
    // eslint-disable-next-line no-eval
    eval("set" + e.target.name + "(\""+ e.target.value + "\")")
  }

  /******************/
  // 家族ホーム画面に戻る
  /******************/
  const handleGoBack = (e) =>{
    UserStatusCheck() //ログイン状態チェック
  }

  /******************/
  // 招待済み家族一覧画面に遷移
  /******************/
  const handleGoToInvitationList = () => {
    navigate('/InvitationList/' + FamilyID)
  }

  // ログイン状態チェック
  const UserStatusCheck=()=>{
    firebase.auth().onAuthStateChanged((user)=>{
      if (user) {
        const db = firebase.firestore()
        var _FamilyID = ''
        setIsLogin(true)
        db.collection("Person").doc(user.uid).get().then((result)=>{
          _FamilyID = result.data().FamilyID[0].id //1件目の家族IDを取得する。
          console.log("push URL: /FamilyHome/" + _FamilyID)
          navigate('/FamilyHome/' + _FamilyID) //ログイン中の場合は、家族ホーム画面に移動する。
        })
      } else {
        setIsLogin(false)
        sessionStorage.clear() //ログインページのリロード管理用のローカルストレージを削除する。
        console.log("push URL: /Login")
        navigate('/Login') //ログイン中でなければ、ログイン画面に移動する。
      }
    })
  }

  /* 招待情報登録 */
  const handleInvitation = async() => {
    // TODO: フォームのバリデーションの方がユーザーフレンドリー?
    if (!Invitation_Email) {
      alert('招待する方のEメールアドレスを入力してください');
      return;
    }

    // メールアドレス文字数チェック（254文字まで）
    if (Invitation_Email.length > 254) {
      alert('メールアドレスは254文字以内で入力してください');
      return;
    }

    // メールアドレス形式チェック
    // https://developer.mozilla.org/ja/docs/Web/HTML/Reference/Elements/input/email
    // 正規表現はinput type="email" の仕様に基づく。
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (!emailRegex.test(Invitation_Email)) {
      alert('正しいメールアドレス形式で入力してください');
      return;
    }

    // お名前文字数チェック（100文字まで）
    if (Invitation_Name && Invitation_Name.length > 100) {
      alert('お名前は100文字以内で入力してください');
      return;
    }

    // メッセージ文字数チェック（1000文字まで）
    if (Message && Message.length > 1000) {
      alert('メッセージは1000文字以内で入力してください');
      return;
    }

    try {
      const db = firebase.firestore();
      
      // 既存の招待情報をチェック
      const existingInvitations = await db.collection("Family").doc(FamilyID).collection("Invitation")
        .where("Invitation_Email", "==", Invitation_Email)
        .get();
      
      // 完了済みの招待があるかチェック
      const completedInvitation = existingInvitations.docs.find(doc => doc.data().Completion === true);
      if (completedInvitation) {
        alert('このメールアドレスは既に招待済みです。');
        return;
      }
      
      // 既存の招待があれば再招待、なければ新規招待
      const existingInvitation = existingInvitations.docs[0];
      const existingInvitationId = existingInvitation ? existingInvitation.id : null;
      
      // 有効期限を設定（現在から2週間後）
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 14);
      const expirationTimestamp = firebase.firestore.Timestamp.fromDate(expirationDate);
      
      let invitationId;
      
      if (existingInvitationId) {
        // 再招待の場合：既存の招待の期限を再設定
        invitationId = existingInvitationId;
        
        const updateData = {
          Active: true,                                  // 招待有効フラグ
          Expiration: expirationTimestamp,               // 有効期限を再設定
          Invitation_Name: Invitation_Name || '',        // 招待対象者のお名前（更新可能）
          UpdateTime: firebase.firestore.FieldValue.serverTimestamp()  // 更新日時
        };
        
        // Family/(FamilyID)/Invitation/(InvitationID) を更新
        await db.collection("Family").doc(FamilyID).collection("Invitation").doc(invitationId).update(updateData);
        
        // Invitation/(InvitationID) を更新
        const invitationUpdateData = {
          ...updateData,
          Message: Message || ''                         // 招待メッセージ（更新可能）
        };
        await db.collection("Invitation").doc(invitationId).update(invitationUpdateData);
        
        console.log("再招待として期限を再設定しました: " + invitationId);
        
      } else {
        // 新規招待の場合
        // 招待IDを生成（ランダムな文字列）
        invitationId = db.collection('Invitation').doc().id;
        
        // Invitation/(InvitationID) 用の招待データを作成
        const invitationData = {
          Active: true,                                  // 招待有効フラグ
          Completion: false,                             // 招待完了フラグ
          Expiration: expirationTimestamp,               // 有効期限
          FamilyID: FamilyID,                            // 家族ID
          Invitation_Email: Invitation_Email,            // 招待対象者のEメールアドレス
          Invitation_Name: Invitation_Name || '',        // 招待対象者のお名前
          Message: Message || '',                        // 招待メッセージ
          Sender_ID: Uid,                                // 招待送信者ID
          Sender_Name: Sender_Name,                      // 招待送信者名
          CreateTime: firebase.firestore.FieldValue.serverTimestamp(), // 作成日時
          UpdateTime: firebase.firestore.FieldValue.serverTimestamp()  // 更新日時
        };
        
        // Family/(FamilyID)/Invitation/(InvitationID) に招待情報を登録
        // FamilyID, Messageは不要
        const familyInvitationData = {
          Active: true,                                  // 招待有効フラグ
          Completion: false,                             // 招待完了フラグ
          Expiration: expirationTimestamp,               // 有効期限
          Invitation_Email: Invitation_Email,            // 招待対象者のEメールアドレス
          Invitation_Name: Invitation_Name || '',        // 招待対象者のお名前
          Sender_ID: Uid,                                // 招待送信者ID
          Sender_Name: Sender_Name,                      // 招待送信者名
          Permission: 'owner',                           // アクセスレベル（初期構築時はownerに限定）
          CreateTime: firebase.firestore.FieldValue.serverTimestamp(), // 作成日時
          UpdateTime: firebase.firestore.FieldValue.serverTimestamp()  // 更新日時
        };
        
        await db.collection("Family").doc(FamilyID).collection("Invitation").doc(invitationId).set(familyInvitationData);
        
        // 2. Invitation/(InvitationID) に招待情報を登録
        await db.collection("Invitation").doc(invitationId).set(invitationData);
        
        console.log("新規招待情報を登録しました: " + invitationId);
      }
      
      console.log("招待する方のEmailアドレス: " + Invitation_Email);
      console.log("招待する方のお名前: " + Invitation_Name);
      console.log("招待ID: " + invitationId);
      
      // 3. SendEmail コレクションにメール送信情報を登録
      const sendEmailID = db.collection('SendEmail').doc().id;
      const sendEmailData = {
        to: [Invitation_Email], // 受信者メールアドレス（配列形式）
        message: {
          subject: `【ふぁみかるくん】${Sender_Name} 様より 招待が届きました`, // メールの件名
          text: `${Invitation_Name ? Invitation_Name + " 様" : ""}

${Sender_Name} 様より ふぁみかるくんアプリへの招待が届きました。

${Message ? Message : ""}

招待を受け取り、${Invitation_Name ? Invitation_Name + " 様" : ""}の家族として家族の健康情報を共同管理するには、
以下のリンクより登録を行ってください。
https://app.famikar.jp/InvitationAccept?InvitationID=${invitationId}

このメールを誤って受け取った場合は。お手数ですが、下記のメールアドレスまでご連絡ください。
info@famikar.jp

以上

----
家族の健康情報家族内共有アプリ　ふぁみかるくん
info@famikar.jp
運営元：株式会社GoMeTo`
        },
        CreateTime: firebase.firestore.FieldValue.serverTimestamp() // 作成日時
      };
      
      await db.collection("SendEmail").doc(sendEmailID).set(sendEmailData);
      console.log("メール送信情報を登録しました: " + sendEmailID);
      
      // 招待情報登録完了
      alert('招待情報を登録しました');
      
      // フォームをクリア
      setInvitation_Email('');
      setInvitation_Name('');
      setMessage('');
      
    } catch (error) {
      console.error("招待情報の登録に失敗しました:", error);
      alert('招待情報の登録に失敗しました: ' + error.message);
    }
  }

  useEffect(() => { //ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    //console.log("compoonentDidMount: FamilyID[" + FamilyID + "]")
    const db = firebase.firestore()
    getLoginInfo(db) // ログイン情報取得
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setUid, setFamilyID]);

  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, []);


  return (
    <React.Fragment>
      {
        /* uidに値がある場合のみヘッダー表示を行う */
        uid && <FamikarHeader uid={uid} FamilyID={FamilyID} isHome={true} />
      }
      {/* this.state.uid && <div>uid: {this.state.uid}</div> */}
      {/* this.state.FamilyID && <div>FamilyID: {this.state.FamilyID}</div> */}
      {/* this.state.Sender && <div>Sender: {this.state.Sender}</div>*/}
      
      {/* 招待フォームのタイトルと招待済み家族一覧リンク */}
      <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{padding: '1em'}}>
        <Grid item>
          家族・関係者を招待しましょう
        </Grid>
        <Grid item>
          <div 
            style={{color: '#2196f3', cursor: 'pointer'}} 
            onClick={()=>handleGoToInvitationList()}
          >
            招待済み家族一覧
          </div>
        </Grid>
      </Grid>
      
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={0} style={{textAlign: 'left'}}>
        <Grid item xs={12} style={{paddingLeft: '2em', paddingRight: '1em', display:'none'}}> {/* 当面の間非表示にする */}
          招待した方に家族の１人の情報を見せるか、<br />
          家族全員の情報を見せるかを選択できます。
        </Grid>
        {/* デバッグ用の表示情報は非表示にする */}
        {/* <Grid item xs={12} style={{paddingLeft: '2em', paddingRight: '1em'}}>
          Uid: {Uid}<br />
          FamilyID: {FamilyID}<br />
          Sender_Name: {Sender_Name}<br />
          Invitation_Email: {Invitation_Email}<br />
          Invitation_Name: {Invitation_Name}<br />
          Message: <div style={{whiteSpace: 'pre-wrap'}}>{Message}</div>
          IsLogin: {IsLogin === true ? "true" : "false"}
        </Grid> */}
        <Grid item xs={12} style={{padding: '1em'}}>
          <label htmlFor="inputEmail" style={{display: 'block', marginBottom: '8px'}}>招待する方のEメールアドレス（必須）</label>
          <Input fullWidth id="inputEmail" placeholder="Eメールアドレスを入力" name="Invitation_Email" value={Invitation_Email} onChange={(e)=>handleChange(e)} />
        </Grid>
        <Grid item xs={12} style={{padding: '1em'}}>
          <label htmlFor="inputName" style={{display: 'block', marginBottom: '8px'}}>招待する方のお名前（任意）</label>
          <Input fullWidth id="inputName" placeholder="お名前を入力" name="Invitation_Name" value={Invitation_Name} onChange={(e)=>handleChange(e)} />
        </Grid>
        <Grid item xs={12} style={{padding: '1em'}}>
          <label htmlFor="inputMessage" style={{display: 'block', marginBottom: '8px'}}>招待する方へのメッセージ（任意）</label>
          <TextField fullWidth multiline minRows={4} variant="outlined" id="inputMessage" placeholder="メッセージを入力" name="Message" value={Message} onChange={(e)=>setMessage(e.target.value)} />
        </Grid>
        {/* 当面の間、アクセス権はフルアクセスのみとする。 2022.12.18
        <Grid item xs={12} style={{padding: '1em'}}>
          招待する方のアクセス権を設定しましょう（必須）
          <TextField fullWidth select id="inputPermission" label="招待対象者のアクセス権限" name="Permission" value={this.state.Permission} onChange={(e)=>this.handleChange(e)}>
          {PermissionList}
          </TextField>
        </Grid>
        <Grid item xs={12} style={{padding: '1em'}}>
          ゲスト権限でアクセス許可するメンバーを設定しましょう（必須）
          <FormControl fullWidth>
            <InputLabel id="inputMemberPermission">対象メンバーを選択しましょう。</InputLabel>
            <Select
              id="inputMemberPermission"
              label="対象メンバーを選択しましょう。"
              name="MemberPermission"
              multiple
              value={this.state.MemberPermission}
              onChange={(e)=>this.handleChange(e)}
            >
              {MemberSelectList}
            </Select>
          </FormControl>
        </Grid>
        */}
      </Grid>
      {/* 画面下部のメニュー */}
      <AppBar position="fixed" style={{backgroundColor: '#FFFFFF', top: 'auto', bottom: '0', boxShadow: 'none'}}>
        <Grid container justifyContent="space-between" alignItems="flex-start" style={{padding: '16px 8px 8px', maxWidth: '480px'}} className="App">
          <Button variant="contained" color="primary" onClick={()=>handleGoBack()}>戻る</Button>
          <Button variant="contained" color="primary" onClick={()=>handleInvitation()}>招待する</Button>
        </Grid>
      </AppBar>
    </React.Fragment>
  )
}

// export default Invitation //withRouter(Invitation)
